import { useTranslation } from '@/app/i18n/client'
import { KeyboardEventHandler } from 'react'
import CreatableSelect from 'react-select/creatable'
import { colourStyles } from './selectStyle'

const components = {
  DropdownIndicator: null,
}

export interface ReactSelectOption {
  id: number
  label: string
  value: string
  __isNew__?: boolean
}

const createOption = (label: string) => ({
  id: -1,
  label,
  value: label,
})

const CreatableMultiSelect = ({
  id,
  inputValue,
  value,
  setValue,
  setInputValue,
  options,
  placeholder,
  createLabel,
  isDisabled = false,
  isLoading = false,
}: {
  id: string
  inputValue: string
  value: ReactSelectOption[]
  setValue: (value: ReactSelectOption[]) => any
  setInputValue: (value: string) => any
  options: ReactSelectOption[]
  placeholder: string
  createLabel: string
  isDisabled?: boolean
  isLoading?: boolean
}) => {
  const { t } = useTranslation()
  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        const isValuepresent = value?.find(
          (item) => item?.value == inputValue.trim()
        )
        if (isValuepresent) {
          return
        }
        const newValue = [...value, createOption(inputValue)]
        setValue(newValue)
        setInputValue('')
        event.preventDefault()
    }
  }

  return (
    <>
      <CreatableSelect
        id={id}
        isDisabled={isDisabled}
        isLoading={isLoading}
        components={components}
        inputValue={inputValue}
        isMulti
        closeMenuOnSelect={false}
        styles={colourStyles}
        options={options}
        formatCreateLabel={(inputValue) => `${t(createLabel)}: "${inputValue}"`}
        onChange={(newValue) => setValue(newValue as ReactSelectOption[])}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
        placeholder={t(placeholder)}
        value={value}
      />
    </>
  )
}

export default CreatableMultiSelect
